import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';

import HTMLView from 'Components/HTMLView';

import { Text } from '../../Base';

import ArticleBoxStyles from './ArticleBoxStyles';
import CodeBoxStyles from './CodeBoxStyles';

const ContentText = styled(Text)`
  ${ArticleBoxStyles}
  ${CodeBoxStyles}
`;

const ArticleObserver = ({ children, onCompleted }) => {
  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      onCompleted();
    }
  }, [inView]);

  return (
    <div style={{ position: 'relative' }}>
      <div ref={ref} style={{ position: 'absolute', bottom: 0, height: '1px' }} />
      {children}
    </div>
  );
};

const ArticleBox = ({ rawContent, onCompleted, onLinkClick }) => {
  const htmlComponent = (
    <ContentText fontFamily="contentReadable" color="articleDetails">
      <HTMLView rawContent={rawContent} onLinkClick={onLinkClick} />
    </ContentText>
  );

  if (onCompleted && typeof onCompleted === 'function') {
    return <ArticleObserver onCompleted={onCompleted}>{htmlComponent}</ArticleObserver>;
  }

  return htmlComponent;
};

export default ArticleBox;
